import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';
import { Schedule } from 'src/app/features/schedule/schedule.types';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  readonly #http = inject(HttpClient);

  get(date?: string, isCasual: boolean = false): Observable<Schedule[]> {
    let params = new HttpParams();
    if (date) {
      params = params.append('date', date);
    }

    const url = isCasual ? 'api/schedules/casual' : 'api/schedules';

    return this.#http.get<Schedule[]>(url, { params })
      .pipe(
        map(res => {
          for (const date of res) {
            date.day = new Date(`${date.day}T00:00+09:00`).toISOString()
          }
          return res;
        })
      )
  }
}
